/**
 * Global Action Types for all of Actions
 */

export const APP_START = 'APP_START';
